'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var helper = require('../../helper/componentHelper.js');
var styleHelper = require('../../helper/styleHelper.js');
var appTypes = require('../../types/appTypes');
var convertHelper = require('../../types/convertHelper');
var ScrollBar = require('../common/ScrollBar');
var graphicsHelper = require('./../../helper/graphicsHelper');
var VerticalScrollBar = require('../common/VerticalScrollBar');
var HorizontalScrollBar = require('../common/HorizontalScrollBar');
var _ = require('underscore');

var Canvas = React.createClass({

  paint: function (props) {
    if(this.props.isShow) {
      var color = this.props.currentColor;
      if(_.isUndefined(color)){
        color = this.props.color;
      }
      graphicsHelper.drawShpae(ReactDOM.findDOMNode(this.refs.canvas).getContext('2d'),
        {
          width: this.currentW,
          height: this.currentH,
          borderType: this.props.shapeBorderType,
          borderVisible: this.props.borderVisible,
          borderColor: this.props.borderColor,
          fillColor: color,
          radius: parseInt(this.props.radius, 10),
          borderWidth: parseInt(this.props.thickness, 10),
          triangleType: this.props.triangleType,
          borderLeft: this.props.rectangleBorderLeftVisible,
          borderTop: this.props.rectangleBorderTopVisible,
          borderRight: this.props.rectangleBorderRightVisible,
          borderBottom: this.props.rectangleBorderBottomVisible
        });
    }
  },

  doAdjustLinkArea: function () {
    var plink = $('#' + this.props.controlID + ' .page-link');
    var interactiveLink = $('#' + this.props.controlID + ' .interactive-link');
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    if (plink) {
      plink.css({
        width: w,
        height: h
      });
    }
    if (interactiveLink) {
      interactiveLink.css({
        width: w,
        height: h
      });
    }
  },

  componentDidUpdate: function (props) {
    this.paint(props);
    this.doAdjustLinkArea();
  },
  componentDidMount: function (props) {
    this.paint(props);
  },


  render: function () {
    this.currentW = styleHelper.getWidth(this.props);
    this.currentH = styleHelper.getHeight(this.props);

    var isShowScrollBar = (this.props.shapeBorderType === appTypes.ShapeType.RECTANGLE) && (this.props.verticalScrollbarShow || this.props.horizontalScrollbarShow);
    var borderVisible = styleHelper.getPropertyValue(this.props,'borderVisible');
    var verticalScrollBarHeight;
    var horizontalScrollBarWidth;
    var thickness = borderVisible ? styleHelper.getBorderWidth(this.props): 0;
    if (isShowScrollBar) {
      if (this.props.verticalScrollbarShow && this.props.horizontalScrollbarShow) {
        verticalScrollBarHeight = this.currentH - 12 - 2 * thickness - 4;
        horizontalScrollBarWidth = this.currentW - 12 - 2 * thickness - 4;
      }
    }
    return (<div
      style={{
        position : 'absolute',
        width : '100%',
        height : '100%',
        left : 0,
        top : 0
      }}
      key={this.props.controlID + '-shape'}>
      <canvas
        ref="canvas"
        style={{
                   position: 'absolute',
                    left :0,
                    top : 0,
                    width : '100%',
                    height : '100%'
                }}
        onChange={this.paint.bind(this,this.props)}
        width={this.currentW}
        height={this.currentH}/>
      {
        isShowScrollBar && this.props.horizontalScrollbarShow &&
        <HorizontalScrollBar
          value={parseInt(this.props.verticalScrollbarProgress, 10)}
          width={horizontalScrollBarWidth}
        />
      }
      {
        isShowScrollBar && this.props.verticalScrollbarShow &&
        <VerticalScrollBar
          value={parseInt(this.props.verticalScrollbarProgress, 10)}
          height={verticalScrollBarHeight}
        />
      }
    </div>);
  }
});

module.exports = Canvas;



/** WEBPACK FOOTER **
 ** ./src/views/Components/Canvas.jsx
 **/